import type { ApiResponse } from '@vision/ui/interfaces';
import type { ActionLog, ActionLogMeta, LoginSessionSummary, LoginSessionUser } from './action-logs.types';

interface LoginSessionUserResponseDto {
  email: string | null;
  id: string;
  name: string | null;
}

interface LoginSessionSummaryResponseDto {
  actual_actor: LoginSessionUserResponseDto;
  auth_method: string;
  browser: string | null;
  effective_user: LoginSessionUserResponseDto;
  ended_at: string | null;
  end_reason: string | null;
  filter_value: string;
  id: string;
  ip_address: string | null;
  started_at: string;
  status: string;
}

export interface ActionLogResponseDto {
  action: string;
  action_date: string;
  action_key: string | null;
  detail: string;
  detail_json?: Record<string, unknown>;
  id: string;
  ip_location: string;
  login_session: LoginSessionSummaryResponseDto | null;
  login_session_id: string | null;
  log_source: string;
  menu: string;
  menu_key: string;
  user_email: string;
  user_name: string;
}

function mapLoginSessionUser(dto: LoginSessionUserResponseDto): LoginSessionUser {
  return { email: dto.email, id: dto.id, name: dto.name };
}

function mapLoginSession(dto: LoginSessionSummaryResponseDto | null): LoginSessionSummary | null {
  if (!dto) return null;

  return {
    actualActor: mapLoginSessionUser(dto.actual_actor),
    authMethod: dto.auth_method,
    browser: dto.browser,
    effectiveUser: mapLoginSessionUser(dto.effective_user),
    endedAt: dto.ended_at,
    endReason: dto.end_reason,
    filterValue: dto.filter_value,
    id: dto.id,
    ipAddress: dto.ip_address,
    startedAt: dto.started_at,
    status: dto.status,
  };
}

function mapActionLog(dto: ActionLogResponseDto): ActionLog {
  return {
    action: dto.action,
    actionDate: dto.action_date,
    actionKey: dto.action_key,
    detail: dto.detail,
    detailJson: dto.detail_json,
    id: dto.id,
    ipLocation: dto.ip_location,
    loginSession: mapLoginSession(dto.login_session),
    logSource: dto.log_source,
    menu: dto.menu,
    menuKey: dto.menu_key,
    userEmail: dto.user_email,
    userName: dto.user_name,
  };
}

export function normalizeActionLogsResponse(
  response: ApiResponse<ActionLogResponseDto[], ActionLogMeta>,
): ApiResponse<ActionLog[], ActionLogMeta> {
  return { ...response, data: response.data.map(mapActionLog) };
}
